import { reactive, computed, onBeforeMount } from '@vue/composition-api'

export const InformationDetail = (props, context) => {
  const store = context.root.$store
  const { infoId } = props
  const { news } = store.state

  onBeforeMount(async () => {
    store
      .dispatch('news/getDetail', infoId)
      .then(() => {
        store.dispatch('common/addTitle', news.detail_data.title)
      })
  })

  const data = reactive({
    publication_day: computed(() => news.detail_data.publication_day),
    classification_name: computed(() => news.detail_data.classification_name),
    category_name: computed(() => news.detail_data.category_name),
    title: computed(() => news.detail_data.title),
    detail: computed(() => news.detail_data.detail),
    classification: computed(() => news.detail_data.classification) // お知らせ重要度
  })

  const state = reactive({
    visibleMenu: false, // SP用
    visibleSearchExtract: false // SP用
  })

  return {
    data,
    state
  }
}
